import ProductVar from '@/classes/productVar';

const state = () => ({
  productVars: {},
});

const getters = {
  get: state => state.productVars,
};

const mutations = {
  set(state, productVars = []) {
    productVars.forEach(pv => {
      const productVar = new ProductVar(pv);
      state.productVars[productVar.type] = productVar;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
